import { Component, OnInit, HostListener } from "@angular/core";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  isMobile!: boolean;
  showSideMenu!: boolean;

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 640;
    this.showSideMenu = !this.isMobile;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    const screenWidth = (event.target as Window).innerWidth;
    this.isMobile = screenWidth <= 640;
  }
}
